<template>
  <div>
    <v-card-title class="elevation-0">
      <span class="itemHeading">LEAVE BALANCE</span>
    </v-card-title>
    <v-tabs v-model="tabValue" background-color="white" grow dark center-active centered :show-arrows="true"
      active-class="activ" class="nonactiv" style="font-family: kumbhSemibold">
      <v-tabs-slider color="#005f32"></v-tabs-slider>
      <v-tab href="#tab-1"><span style="color: black">My Leave Balance</span></v-tab>
      <v-tab href="#tab-2"><span style="color: black">Team Members’ Leave Balance</span></v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-layout wrap justify-start py-5>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="leaveType"
                :items="leaveTypes"
                label="Leave Type"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="fyear"
                :items="fyears"
                label="Financial Year"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 pl-3 text-left>
              <LeaveBalanceTable
                :view-type="'my'"
                :current-page="currentPage"
                :leave-type="leaveType"
                :fyear="fyear"
                @page-changed="onPageChanged"
                :key="tabValue + leaveType + fyear"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <v-layout wrap justify-end py-5>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="leaveType"
                :items="leaveTypes"
                label="Leave Type"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-select
                v-model="fyear"
                :items="fyears"
                label="Financial Year"
                class="rounded-xl"
                outlined
                dense
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3 pl-3 pb-3>
              <v-text-field
                v-model="searchQuery"
                label="Search"
                class="rounded-xl"
                prepend-inner-icon="mdi-magnify"
                clearable
                @input="onSearch"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 pl-3 text-left>
              <LeaveBalanceTable
                :view-type="'team'"
                :current-page="currentPage"
                :search-query="searchQuery"
                :leave-type="leaveType"
                :fyear="fyear"
                @page-changed="onPageChanged"
                :key="tabValue + leaveType + fyear"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import LeaveBalanceTable from './LeaveBalanceTable.vue';

export default {
  components: {
    LeaveBalanceTable
  },
  data() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    let startYear = currentMonth >= 3 ? currentYear : currentYear - 1;
    const fyears = [];
    for (let i = 0; i < 5; i++) {
      fyears.push(`${startYear - i}-${startYear - i + 1}`);
    }
    return {
      tabValue: 'tab-1',
      currentPage: 1,
      searchQuery: '',
      leaveType: 'Casual',
      leaveTypes: ['Casual', 'Festival'],
      fyear: fyears[0],
      fyears: fyears
    };
  },
  watch: {
    tabValue() {
      this.currentPage = 1; // Reset page when tab changes
      this.searchQuery = ''; // Reset search query when tab changes
    },
    leaveType() {
      this.currentPage = 1; // Reset page when leave type changes
    }
  },
  methods: {
    onPageChanged(page) {
      this.currentPage = page;
    },
    onSearch() {
      this.currentPage = 1; // Reset to first page on search
    }
  }
};
</script>

<style>
.itemHeading {
  font-size: 22px;
  font-family: kumbhSemibold;
  color: #005f32;
}
</style>